import { render, staticRenderFns } from "./VerticalLayoutMoreContent.vue?vue&type=template&id=3c4b4ff3&scoped=true"
import script from "./VerticalLayoutMoreContent.vue?vue&type=script&lang=js"
export * from "./VerticalLayoutMoreContent.vue?vue&type=script&lang=js"
import style0 from "./VerticalLayoutMoreContent.vue?vue&type=style&index=0&id=3c4b4ff3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4b4ff3",
  null
  
)

export default component.exports